export type PlanningDuplicateEntityType = 'cycle' | 'objective' | 'meta' | 'marco' | 'task';

export type PlanningDuplicateCascadeOptions = {
  includeObjectives: boolean;
  includeMetas: boolean;
  includeMarcos: boolean;
  includeTasks: boolean;
};

export type PlanningDuplicateCascadeOption = {
  id: keyof PlanningDuplicateCascadeOptions;
  label: string;
  description: string;
  count?: number;
  disabled?: boolean;
};

export function getPlanningDuplicateOptions(
  entityType: PlanningDuplicateEntityType,
  counts: {
    objectives?: number;
    metas?: number;
    marcos?: number;
    tasks?: number;
  } = {},
): PlanningDuplicateCascadeOption[] {
  if (entityType === 'cycle') {
    return [
      {
        id: 'includeObjectives',
        label: 'Objetivos',
        description: 'Duplicar todos os objetivos do ciclo.',
        count: counts.objectives,
        disabled: !counts.objectives,
      },
      {
        id: 'includeMetas',
        label: 'Metas',
        description: 'Incluir todas as metas dos objetivos estratégicos.',
        count: counts.metas,
        disabled: !counts.metas,
      },
      {
        id: 'includeMarcos',
        label: 'Marcos',
        description: 'Incluir todos os marcos vinculados às metas.',
        count: counts.marcos,
        disabled: !counts.marcos,
      },
      {
        id: 'includeTasks',
        label: 'Tarefas',
        description: 'Incluir todas as tarefas da hierarquia e avulsas.',
        count: counts.tasks,
        disabled: !counts.tasks,
      },
    ];
  }

  if (entityType === 'objective') {
    return [
      {
        id: 'includeMetas',
        label: 'Metas',
        description: 'Duplicar todas as metas deste objetivo.',
        count: counts.metas,
        disabled: !counts.metas,
      },
      {
        id: 'includeMarcos',
        label: 'Marcos',
        description: 'Duplicar todos os marcos das metas.',
        count: counts.marcos,
        disabled: !counts.marcos,
      },
      {
        id: 'includeTasks',
        label: 'Tarefas',
        description: 'Duplicar todas as tarefas vinculadas.',
        count: counts.tasks,
        disabled: !counts.tasks,
      },
    ];
  }

  if (entityType === 'meta') {
    return [
      {
        id: 'includeMarcos',
        label: 'Marcos',
        description: 'Duplicar todos os marcos desta meta.',
        count: counts.marcos,
        disabled: !counts.marcos,
      },
      {
        id: 'includeTasks',
        label: 'Tarefas',
        description: 'Duplicar todas as tarefas dos marcos.',
        count: counts.tasks,
        disabled: !counts.tasks,
      },
    ];
  }

  if (entityType === 'marco') {
    return [
      {
        id: 'includeTasks',
        label: 'Tarefas',
        description: 'Duplicar todas as tarefas deste marco.',
        count: counts.tasks,
        disabled: !counts.tasks,
      },
    ];
  }

  return [];
}
